import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Router, RouterLink, RouterLinkActive, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { DefineSidebarComponent } from './define-sidebar/define-sidebar.component';
import { SpacesSidebarComponent } from './spaces-sidebar/spaces-sidebar.component';
import { ViewSidebarComponent } from './view-sidebar/view-sidebar.component';

@Component({
    selector: 'app-sidebar',
    imports: [RouterLink, RouterLinkActive, DefineSidebarComponent, SpacesSidebarComponent, ViewSidebarComponent],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  currentRoute = '';

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.urlAfterRedirects;
      });
  }

  get isDefinePage(): boolean {
    return this.currentRoute === '/define' || this.currentRoute.startsWith('/define/');
  }

  get isSpacesPage(): boolean {
    return this.currentRoute.startsWith('/spaces');
  }

  get isViewPage(): boolean {
    return this.currentRoute.startsWith('/view');
  }
}
